import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const NotificationActions = createActionGroup({
  source: 'Notification',
  events: {
    'Add Error': props<{ messageKey: string }>(),
    'Add Success': props<{ messageKey: string }>(),
    'Hide': emptyProps(),
  },
});
